import FilesAPI from '@/api/workspace'

export async function uploadFormDataFiles(data) {
  const directionsId = [];
  for(const dir of data.educationDirections)
    directionsId.push(dir.id)  
  const addedFiles = [];
  if(data.image) {
    const info = await FilesAPI.uploadFiles(data.image);
    for(const val of info.data) {
      addedFiles.push(val);
    }
  }
  if(data.video) {
    const info = await FilesAPI.uploadFiles(data.video);
    for(const val of info.data) {
      addedFiles.push(val);
    }
  }
      
  if(data.presentation) {
    const info = await FilesAPI.uploadFiles([data.presentation]);
    for(const val of info.data) {
      addedFiles.push(val);
    }
  }

  return {addedFiles, directionsId};
}
